import { Typography } from '@mui/material';
import { ProfileDetailsSection } from './ProfileDetailsSection';
import { ResetPassword } from './ResetPasswordSection';
import { Trans } from 'react-i18next';

export const Profile = () => {
  return (
    <div className="flex flex-col w-full">
      <div className="mb-10">
        <Typography variant="h4" fontWeight={500}>
          <Trans i18nKey="profile.title" />
        </Typography>
      </div>

      <div className="flex gap-8">
        <div className="flex-1 basis-1/2">
          <div className="mb-10">
            <Typography variant="h5" fontWeight={500}>
              <Trans i18nKey="profile.change_company_details" />
            </Typography>
          </div>
          <ProfileDetailsSection />
        </div>
        <div className="flex-1 basis-1/2">
          <div className="mb-10">
            <Typography variant="h5" fontWeight={500}>
              <Trans i18nKey="profile.change_password" />
            </Typography>
          </div>
          <ResetPassword />
        </div>
      </div>
    </div>
  );
};
